import React from 'react'
import { HooksMonitor } from '@edge-stream/observability-react'

export function HooksPage(): React.ReactElement {
  return <HooksMonitor className="page-container" showSettings={true} pollInterval={500} maxLogs={100} />
}
